import HomePage from "../pages/HomePage";
import LogInPage from "../pages/LogInPage";
import CancelPage from "../pages/CancelPage";
import SuccessPage from "../pages/SuccessPage";
import LandingPage from "../pages/LandingPage";
import AdsPage from "../pages/AdsPage/AdsPage";
import AdsProductPage from "../pages/AdsPage/AdsProductPage";
import SettingsPage from "../pages/SettingsPage";
import WebsitesPage from "../pages/WebsitesPage";
import StartSurvery from "../forms/StartSurvery";
import { PlansPage } from "../pages/Plans/PlansPage";
import SalesPage from "../pages/SalesPage/SalesPage";
import LandingOfferPage from "../pages/LandingOfferPage";
import SentryTestPage from "../components/SentryTestPage";
import UserPreferencesPage from "../pages/UserPreferences";
import ProductsPage from "../pages/productPage/productPage";
import { PaymentResultPage } from "../pages/PaymentResultPage";
import AnalyticsPage from "../pages/AnaliticsPage/AnalyticsPage";
import OnboardingFakePage from "../pages/FunnelCreationFakePage";
import AbTestingPage from "../components/ab-testing/AbTestingPage";
import WebsitesBuilderIFramePage from "../pages/WebsiteBuilderIframePage";
import { MembershipPage } from "../pages/membershipsPage/MembershipsPage";
import { IntegrationsPage } from "../pages/Integrations/IntegrationsPage";
import ChatPage from "../pages/ChatPage/ChatPage";
import { OrderDetailsPage } from "../pages/OrderDetailsPage/OrderDetailsPage";
import { AbandonedCartDetailPage } from "../pages/AbandonedCartDetailPage/AbandonedCartDetailPage";
import { OnboardingLayout } from "../components/onboardingNew/OnboardingLayout";
import { OnboardingLayoutHome } from "../components/onboardingHome/OnboardingLayoutHome";
import OnboardingGuard from "./OnboardingGuard";
import { OnboardingLayoutHomeDemo } from "../components/onboardingHome1/OnboardingLayoutHomeDemo";
import HyphensPage from "@/pages/hyphens/HyphensPage";
import { SwitchGuestPage } from "@/pages/GuestPage/SwitchGuest.page";

export const protectedRoutes = [
  { path: "/ads", element: <AdsPage /> },
  { path: "/ads/product/:productId", element: <AdsProductPage /> },
  { path: "/hyphens", element: <HyphensPage /> },
  { path: "/home", element: <HomePage /> },
  { path: "/plans", element: <PlansPage /> },
  { path: "/orders", element: <SalesPage /> },
  { path: "/survey", element: <StartSurvery /> },
  { path: "/funnels", element: <WebsitesPage /> },
  { path: "/products", element: <ProductsPage /> },
  { path: "/settings", element: <SettingsPage /> },
  { path: "/ab-testing", element: <AbTestingPage /> },
  { path: "/membership", element: <MembershipPage /> },
  { path: "/sentry-test", element: <SentryTestPage /> },
  { path: "/onboarding", element: <OnboardingGuard><OnboardingLayout /></OnboardingGuard> },
  { path: "/integrations", element: <IntegrationsPage /> },
  ...(import.meta.env.VITE_DISABLED_CHAT !== "true"
    ? [{ path: "/chat", element: <ChatPage /> }]
    : []),
  { path: "/onboarding1", element: <OnboardingFakePage /> },
  { path: "/order/:hash_id", element: <OrderDetailsPage /> },
  { path: "/abandoned-cart/:session_id", element: <AbandonedCartDetailPage /> },
  { path: "/analytics/:website_id", element: <AnalyticsPage /> },
  { path: "/onboarding/home", element: <OnboardingGuard><OnboardingLayoutHome /></OnboardingGuard> },
  { path: "/user/preferences", element: <UserPreferencesPage /> },
  { path: "/onboarding1/home1", element: <OnboardingLayoutHomeDemo /> },
  { path: "/complete-email-setup", element: <SwitchGuestPage /> },
];

export const publicRoutes = [
  { path: "/", element: <LandingPage /> },
  { path: "/login", element: <LogInPage /> },
  { path: "/login/offer", element: <LandingOfferPage /> },
  { path: "/payment/:status", element: <PaymentResultPage /> },
  { path: "/payment-subscription/cancel", element: <CancelPage /> },
  { path: "/payment-subscription/success", element: <SuccessPage /> },
  { path: "/website/builder/guest", element: <WebsitesBuilderIFramePage /> },
];
